import "./Captcha.css";

export const Captcha = ({ value, onReload }) => {
  return (
    <div className="captcha-container">
      <div className="captcha-text">{value}</div>
      <button type="button" onClick={onReload} className="reload-button">
        Reload
      </button>
    </div>
  );
};
